// Xalqaro/metrik belgi bo'lgan birliklar (kg, m² kabi) — bu belgilar HAR QANDAY
// tilda bir xil va universal tan olingan, shuning uchun hech qachon tarjima
// qilinmaydi, doim qisqartma (shortName) ko'rinishida ko'rsatiladi.
const SYMBOL_UNITS = new Set(['kg', 'g', 't', 'l', 'ml', 'm', 'cm', 'mm', 'm²', 'm³', 'km']);

// O'lchov birligini joriy tilga o'giradi (asosiy frontend'dagi uomLabel bilan
// bir xil mantiq — client-app alohida ilova bo'lgani uchun mustaqil nusxa).
// Argument — UOM obyekti ({shortName, fullName}) yoki shortName string bo'lishi mumkin.
export function uomLabel(uomOrShort, t) {
  if (!uomOrShort) return '';
  const short = typeof uomOrShort === 'string' ? uomOrShort : (uomOrShort.shortName || '');
  if (!short) return typeof uomOrShort === 'object' ? (uomOrShort.fullName || '') : '';
  if (SYMBOL_UNITS.has(short)) return short;
  if (t) {
    const tr = t('uomNames.' + short);
    if (tr && !String(tr).startsWith('uomNames.')) return tr;
  }
  return typeof uomOrShort === 'object' ? (uomOrShort.fullName || short) : short;
}
